import React, { useEffect } from "react";
import { ToastContainer } from 'react-toastify';
import { Helmet } from "react-helmet"; 
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

// Imports for Images
import googleIcon from './../../assets/google_icon.jpg';
import appleIcon from './../../assets/apple_icon.jpg';
import galaxyBg from './../../assets/galaxy_bg.jpg'; 

// URLs
const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.Eventyol.Sinanium2";
const IOS_URL = "https://apps.apple.com/app/id6757132934";

// Metadata
const META_TITLE = "Sinanium: Galactic Dominion";
const META_DESCRIPTION = "Commander! Join my alliance and conquer the galaxy in this 4X Space Strategy RTS. Download now on iOS & Android.";
const META_IMAGE = "https://eventyol.org/invite-card.jpg"; 
const META_URL = "https://eventyol.org/sinanium-galactic";

const colors = {
  white: "#ffffff",
};

const SinaniumInvite = () => {

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let targetUrl = ANDROID_URL; 
    
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      targetUrl = IOS_URL;
    }

    // Uncomment this line when you are ready to auto-redirect users!
    window.location.replace(targetUrl);
    
  }, []);

  return (
    <div style={{ 
      backgroundImage: `url(${galaxyBg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh',
      width: '100vw',
      position: 'relative',
      overflow: 'hidden'
    }}>
      
      {/* START META TAGS */}
      <Helmet>
        <title>{META_TITLE}</title>
        <meta name="description" content={META_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={META_URL} />
        <meta property="og:title" content={META_TITLE} />
        <meta property="og:description" content={META_DESCRIPTION} />
        <meta property="og:image" content={META_IMAGE} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={META_URL} />
        <meta property="twitter:title" content={META_TITLE} />
        <meta property="twitter:description" content={META_DESCRIPTION} />
        <meta property="twitter:image" content={META_IMAGE} />
      </Helmet>
      {/* END META TAGS */}

      {/* Dark Overlay */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "black",
        opacity: 0.6,
        zIndex: 1
      }}></div>

      {/* Content Layer */}
      <div style={{ position: "relative", zIndex: 2, width:"100%", height: "100vh", display: "flex", flexDirection: "column" }}>
        
        {/* Navbar */}
        <Navbar collapseOnSelect expand="lg" style={{ backgroundColor: 'transparent', borderBottom: "1px solid rgba(255,255,255,0.3)" }}>
          <Container style={{ justifyContent: 'center' }}> {/* Centered Brand */}
            <Navbar.Brand href="#home" style={{ color: colors.white, fontWeight: "bold", fontSize: 32, fontFamily: "Irish Grover" }}>
              Sinanium
            </Navbar.Brand>
          </Container>
        </Navbar>

        {/* Main Text & Buttons Area */}
        <div style={{ 
            flex: 1, 
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            alignItems: "center", // <--- Centers content horizontally
            textAlign: "center",   // <--- Centers text lines
            paddingLeft: 20, 
            paddingRight: 20 
        }}>
            <h1 style={{ 
                color: "white", 
                fontSize: 42, 
                fontFamily: "Irish Grover", 
                marginBottom: 20,
                textShadow: "2px 2px 4px rgba(0,0,0,0.8)" 
            }}>
              Conquer the Galaxy
            </h1>
            
            <p style={{ 
                color: "white", 
                fontSize: 18, 
                maxWidth: "600px", 
                lineHeight: 1.5,
                marginBottom: 30,
                textShadow: "1px 1px 2px rgba(0,0,0,0.8)" 
            }}>
              Commander! Your fleet awaits. Join the alliance, build your empire, and battle for supremacy in the ultimate 4X Space Strategy RTS. 
              <br/><br/>
              <strong>Download now to claim your dominion!</strong>
            </p>

            {/* Buttons Container */}
            <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              flexWrap: "wrap", 
              gap: "20px" // Adds space between buttons
            }}>
              <a href={ANDROID_URL} target="_blank" rel="noopener noreferrer">
                <img
                  style={{ width: "160px", borderRadius: 8, border: "1px solid white" }}
                  src={googleIcon}
                  className="Store-logo"
                  alt="Get it on Google Play"
                />
              </a>
              <a href={IOS_URL} target="_blank" rel="noopener noreferrer">
                <img
                  style={{ width: "160px", borderRadius: 8, border: "1px solid white" }}
                  src={appleIcon}
                  className="Store-logo"
                  alt="Download on the App Store"
                />
              </a>
            </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default SinaniumInvite;